<template>
  <div class="bodycontent">
    <div class="page_title">
      补单设置
    </div>
    <div class="page_form">
      <el-form
        :model="formData"
        size="small"
        label-width="120px"
        :inline="true"
      >
        <el-form-item label="名称">
          <!-- <el-select v-model="formData.type" style="width:310px">
            <el-option label="365打印机" value="1"></el-option>
          </el-select> -->
          <el-input
            v-model="formData.goods_title"
            class="inputWidth"
          ></el-input>
        </el-form-item>

        <el-form-item label="油品单价">
          <!-- <el-select v-model="formData.type" class="inputWidth">
            <el-option label="365打印机" value="1"></el-option>
          </el-select> -->
          <el-input v-model="formData.price" class="inputWidth"></el-input>
        </el-form-item>
        <el-form-item label="油枪号">
          <!-- <el-select v-model="formData.type" class="inputWidth">
            <el-option label="365打印机" value="1"></el-option>
          </el-select> -->
          <el-input v-model="formData.device" class="inputWidth"></el-input>
        </el-form-item>
        <el-form-item label="升数">
          <!-- <el-select v-model="formData.type" class="inputWidth">
            <el-option label="365打印机" value="1"></el-option>
          </el-select> -->
          <el-input v-model="formData.num" class="inputWidth"></el-input>
        </el-form-item>
        <el-form-item label="应收">
          <!-- <el-select v-model="formData.type" class="inputWidth">
            <el-option label="365打印机" value="1"></el-option>
          </el-select> -->
          <el-input
            v-model="formData.total_money"
            class="inputWidth"
          ></el-input>
        </el-form-item>
        <el-form-item label="获得积分">
          <!-- <el-select v-model="formData.type" class="inputWidth">
            <el-option label="365打印机" value="1"></el-option>
          </el-select> -->
          <el-input v-model="formData.take_point" class="inputWidth"></el-input>
        </el-form-item>
        <el-form-item label="总积分">
          <!-- <el-select v-model="formData.type" class="inputWidth">
            <el-option label="365打印机" value="1"></el-option>
          </el-select> -->
          <el-input v-model="formData.all_point" class="inputWidth"></el-input>
        </el-form-item>
        <el-form-item label="支付方式">
          <!-- <el-select v-model="formData.type" class="inputWidth">
            <el-option label="365打印机" value="1"></el-option>
          </el-select> -->
          <el-input v-model="formData.pay_type" class="inputWidth"></el-input>
        </el-form-item>
        <el-form-item label="实收">
          <!-- <el-select v-model="formData.type" class="inputWidth">
            <el-option label="365打印机" value="1"></el-option>
          </el-select> -->
          <el-input v-model="formData.money" class="inputWidth"></el-input>
        </el-form-item>
        <el-form-item label="操作员">
          <!-- <el-select v-model="formData.type" class="inputWidth">
            <el-option label="365打印机" value="1"></el-option>
          </el-select> -->
          <el-input v-model="formData.opreater" class="inputWidth"></el-input>
        </el-form-item>
        <el-form-item label="用户电话">
          <!-- <el-select v-model="formData.type" class="inputWidth">
            <el-option label="365打印机" value="1"></el-option>
          </el-select> -->
          <el-input v-model="formData.phone" class="inputWidth"></el-input>
        </el-form-item>
        <el-form-item label="地址">
          <!-- <el-select v-model="formData.type" class="inputWidth">
            <el-option label="365打印机" value="1"></el-option>
          </el-select> -->
          <el-input v-model="formData.address" class="inputWidth"></el-input>
        </el-form-item>
        <el-form-item label="车牌号">
          <!-- <el-select v-model="formData.type" class="inputWidth">
            <el-option label="365打印机" value="1"></el-option>
          </el-select> -->
          <el-input v-model="formData.car_num" class="inputWidth"></el-input>
        </el-form-item>
        <el-form-item label="门店">
          <el-select v-model="formData.room_id" class="inputWidth">
            <el-option v-for="item in storeList" :key="item.id" :label="item.name" :value="item.id"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="下单时间">
          <el-date-picker
            v-model="dateValue[0]"
            type="date"
            class="time_picker_box"
            placeholder="开始日期"
            value-format="yyyy-MM-dd"
            size="small"
          ></el-date-picker>
          <el-time-picker
            placeholder="时间"
            v-model="dateValue[1]"
            class="time_picker_box"
            format="HH:mm:ss"
            value-format="HH:mm:ss"
            size="small"
          ></el-time-picker>
          <!-- <el-input v-model="formData.price" class="inputWidth"></el-input> -->
        </el-form-item>
      </el-form>
    </div>
    <div class="save_button">
      <el-button size="small" type="primary" @click="save()">确定</el-button>
    </div>
  </div>
</template>
<script>
import { define_print } from "@/api/set";
import { selectStoreList } from "@/api/storeManage"
import { mapGetters } from "vuex";
export default {
  inject: ["reload"],
  computed: {
    ...mapGetters(["token", "app_id"])
  },
  data() {
    return {
      formData: {},
      dateValue: [],
      storeList: [], // 门店选项
    };
  },
  mounted(){
    this.init();
  },
  methods: {
    init(){
      selectStoreList({app_id: this.app_id}).then(res => {
        if(res.code == 200) {
          this.storeList = res.data;
        }else{
          this.$message(res.msg)
        }
      })
    },
    save() {
      var data = Object.assign({}, this.formData);
      data.token = this.token;
      data.app_id = this.app_id;
      if (this.dateValue.length != 2) {
        this.$message.warning("请填写下单时间！！");
        return;
      }
      data.create_time = this.dateValue.join(" ");
      console.log(data);
      // return false;
      define_print(data).then(res => {
        if (res.code == 200) {
          this.reload();
          this.$message({
            type: "success",
            message: res.msg
          });
        } else {
          this.$message(res.msg);
        }
      });
    }
  }
};
</script>
<style lang="scss" scoped>
.bodycontent {
  border: 20px solid #f0f2f5;
  height: 100%;
  overflow: auto;
  padding: 0 18px;
  .page_title {
    height: 60px;
    line-height: 60px;
    font-size: 18px;
    border-bottom: 1px dashed #eee;
  }
  .page_form {
    padding-top: 30px;
    .input_box {
      width: 150px;
      margin-right: 10px;
    }
    .input_box_small {
      width: 50px;
    }
    .form_info_text {
      color: #aaa;
    }
  }
  .save_button {
    margin-top: 25px;
    padding-left: 100px;
    margin-bottom: 50px;
  }
  .inputWidth {
    width: 210px;
  }
  .time_picker_box {
    width: 140px;
  }
}
</style>
